import Util from "@/js/common/Util";

interface Props {
    item       : any;
    historyList: any[];
    joinPeriod : string;
}

const MbrasInfoPdf = ({ item, historyList, joinPeriod }: Props) => {
    const renderValue = (value: any) => Util.isEmpty(value) ? "-" : String(value);

    const visibleHistoryList   = historyList.slice(0, 5);
    const remainingHistoryCnt = Math.max(historyList.length - 5, 0);

    const today = new Date();
    const printDate = `${today.getFullYear()}.${String(today.getMonth() + 1).padStart(2, "0")}.${String(today.getDate()).padStart(2, "0")}`;

    return (
        <div
            className="bgcWhite bsBdb fm-c fc111111"
            style={{
                width: "210mm",
                height: "296mm",
                padding: "12mm 14mm 10mm",
                boxSizing: "border-box",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <div style={{ flex: 1 }}>
                <div className="w100p dpFlx aiC jcSb bdt1 bdc1E466A bdb1" style={{ minHeight: "58px" }}>
                    <div className="flx1 taC fm-c fs25 ls06" style={{ paddingLeft: "95px" }}>전국우정노동조합 조합원 가입정보</div>
                    <div className="w100 dpFlx aiC jcE">
                        <img src="/assets/img/common/logo.png" alt="logo" style={{ width: "100px", objectFit: "contain" }} />
                    </div>
                </div>

                <div className="mt30 fm-c fs17 ls06">조합원 정보</div>

                <table className="w100p mt20 fm-c fs14" style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                    <colgroup>
                        <col style={{ width: "22%" }} />
                        <col style={{ width: "28%" }} />
                        <col style={{ width: "22%" }} />
                        <col style={{ width: "28%" }} />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th className="h36 bgcf0f8ff fm-c fs14 fw400 taC" style={{ border: "1px solid #d6d6d6" }}>성명</th>
                            <td className="h36 fm-c fs14 taC" style={{ border: "1px solid #d6d6d6", padding: "0 8px" }}>{renderValue(item.mbrasNm)}</td>
                            <th className="h36 bgcf0f8ff fm-c fs14 fw400 taC" style={{ border: "1px solid #d6d6d6" }}>휴대전화번호</th>
                            <td className="h36 fm-c fs14 taC" style={{ border: "1px solid #d6d6d6", padding: "0 8px" }}>{renderValue(Util.setPhoneNum(item.telno))}</td>
                        </tr>
                        <tr>
                            <th className="h36 bgcf0f8ff fm-c fs14 fw400 taC" style={{ border: "1px solid #d6d6d6" }}>생년월일</th>
                            <td className="h36 fm-c fs14 taC" style={{ border: "1px solid #d6d6d6", padding: "0 8px" }}>{renderValue(Util.cvtDateStrForm(item.brdtDate, "-", "YYYYMMDD"))}</td>
                            <th className="h36 bgcf0f8ff fm-c fs14 fw400 taC" style={{ border: "1px solid #d6d6d6" }}>성별</th>
                            <td className="h36 fm-c fs14 taC" style={{ border: "1px solid #d6d6d6", padding: "0 8px" }}>{renderValue(Util.getValToCode("GNDR_CD", item.gndrCd))}</td>
                        </tr>
                        <tr>
                            <th className="h36 bgcf0f8ff fm-c fs14 fw400 taC" style={{ border: "1px solid #d6d6d6" }}>본부</th>
                            <td className="h36 fm-c fs14 taC" style={{ border: "1px solid #d6d6d6", padding: "0 8px" }}>{renderValue(Util.getUpOrgName(item.upOgnzCd))}</td>
                            <th className="h36 bgcf0f8ff fm-c fs14 fw400 taC" style={{ border: "1px solid #d6d6d6" }}>근로형태</th>
                            <td className="h36 fm-c fs14 taC" style={{ border: "1px solid #d6d6d6", padding: "0 8px" }}>{renderValue(Util.getValToCode("LBR_SHP_SE_CD", item.lbrShpSeCd))}</td>
                        </tr>
                        <tr>
                            <th className="h36 bgcf0f8ff fm-c fs14 fw400 taC" style={{ border: "1px solid #d6d6d6" }}>지부</th>
                            <td className="h36 fm-c fs14 taC" style={{ border: "1px solid #d6d6d6", padding: "0 8px" }}>{renderValue(Util.getDownOrgName(item.ogdpOrgCd))}</td>
                            <th className="h36 bgcf0f8ff fm-c fs14 fw400 taC" style={{ border: "1px solid #d6d6d6" }}>직종</th>
                            <td className="h36 fm-c fs14 taC" style={{ border: "1px solid #d6d6d6", padding: "0 8px" }}>{renderValue(Util.getValToCode("OCPT_TYPE_CD", item.ocptTypeCd))}</td>
                        </tr>
                        <tr>
                            <th className="h36 bgcf0f8ff fm-c fs14 fw400 taC" style={{ border: "1px solid #d6d6d6" }}>관내</th>
                            <td className="h36 fm-c fs14 taC" style={{ border: "1px solid #d6d6d6", padding: "0 8px" }}>{renderValue(item.wtjrNm)}</td>
                            <th className="h36 bgcf0f8ff fm-c fs14 fw400 taC" style={{ border: "1px solid #d6d6d6" }}>상태</th>
                            <td className="h36 fm-c fs14 taC" style={{ border: "1px solid #d6d6d6", padding: "0 8px" }}>{renderValue(Util.getValToCode("MBRAS_JOIN_STTS_CD", item.mbrasJoinSttsCd))}</td>
                        </tr>
                        <tr>
                            <th className="h36 bgcf0f8ff fm-c fs14 fw400 taC" style={{ border: "1px solid #d6d6d6" }}>입직년월일</th>
                            <td className="h36 fm-c fs14 taC" style={{ border: "1px solid #d6d6d6", padding: "0 8px" }}>{renderValue(Util.cvtDateStrForm(item.frstJncmpYmd, "-", "YYYYMMDD"))}</td>
                            <th className="h36 bgcf0f8ff fm-c fs14 fw400 taC" style={{ border: "1px solid #d6d6d6" }}></th>
                            <td className="h36 fm-c fs14 taC" style={{ border: "1px solid #d6d6d6", padding: "0 8px" }}></td>
                        </tr>
                        <tr>
                            <th className="h46 bgcf0f8ff fm-c fs14 fw400 taC" style={{ border: "1px solid #d6d6d6" }}>주소</th>
                            <td className="h46 fm-c fs14" colSpan={3} style={{ border: "1px solid #d6d6d6", padding: "7px 15px", wordBreak: "break-all", lineHeight: "22px" }}>{renderValue(item.addr)}</td>
                        </tr>
                    </tbody>
                </table>

                <div className="mt30 dpFlx aiC jcSb">
                    <div className="fm-c fs17 ls06">조합원 가입 이력</div>
                    <div className="fm-c fs14">가입기간 {joinPeriod || "0개월"}</div>
                </div>

                <table className="w100p mt20 fm-c fs14" style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                    <colgroup>
                        <col style={{ width: "20%" }} />
                        <col style={{ width: "20%" }} />
                        <col style={{ width: "20%" }} />
                        <col style={{ width: "20%" }} />
                        <col style={{ width: "20%" }} />
                    </colgroup>
                    <thead>
                        <tr>
                            <th className="h36 bgcf0f8ff fm-b fs14 taC" style={{ border: "1px solid #d6d6d6" }}>구분</th>
                            <th className="h36 bgcf0f8ff fm-b fs14 taC" style={{ border: "1px solid #d6d6d6" }}>신청일</th>
                            <th className="h36 bgcf0f8ff fm-b fs14 taC" style={{ border: "1px solid #d6d6d6" }}>상신일</th>
                            <th className="h36 bgcf0f8ff fm-b fs14 taC" style={{ border: "1px solid #d6d6d6" }}>승인일자</th>
                            <th className="h36 bgcf0f8ff fm-b fs14 taC" style={{ border: "1px solid #d6d6d6" }}>등록월</th>
                        </tr>
                    </thead>
                    <tbody>
                        {visibleHistoryList.map((history: any, index: number) => (
                            <tr key={history.mbrasAtrzDocId || index}>
                                <td className="h36 fm-c fs14 taC" style={{ border: "1px solid #d6d6d6", padding: "0 8px" }}>{renderValue(Util.getValToCode("MBRAS_ATRZ_SE_CD", history.mbrasAtrzSeCd))}</td>
                                <td className="h36 fm-c fs14 taC" style={{ border: "1px solid #d6d6d6", padding: "0 8px" }}>{renderValue(Util.cvtDateStrForm(history.applyDt, "-", "YYYYMMDD"))}</td>
                                <td className="h36 fm-c fs14 taC" style={{ border: "1px solid #d6d6d6", padding: "0 8px" }}>{renderValue(Util.cvtDateStrForm(history.atrzReqDt, "-", "YYYYMMDD"))}</td>
                                <td className="h36 fm-c fs14 taC" style={{ border: "1px solid #d6d6d6", padding: "0 8px" }}>{renderValue(Util.cvtDateStrForm(history.atrzDt, "-", "YYYYMMDD"))}</td>
                                <td className="h36 fm-c fs14 taC" style={{ border: "1px solid #d6d6d6", padding: "0 8px" }}>{renderValue(Util.cvtMonthStrForm(history.regMm))}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {remainingHistoryCnt > 0 && (
                    <div className="mt10 taC fm-c fs13 fc333333">
                        표시되지 않은 변경 이력이 {remainingHistoryCnt}건 더 있습니다.
                    </div>
                )}

                <div className="mt50 p16 bgcFAFAFA bdrd4 fm-c fs14 lh27" style={{ border: "1px solid #e5e5e5", textAlign: "justify" }}>
                    상기 본인은 전국우정노동조합 규약 및 제반 규정을 준수할 것을 서약하고, 노동조합 가입원서를 제출하였으며, 규약에 따른 조합비 일괄공제 및 가입신청서의 개인정보 처리에 동의합니다.
                </div>

                <div className="mt50 dpFlx jcE aiC fm-c fs15" style={{ paddingRight: "45px" }}>
                    <span className="mr15">조합원</span>
                    <span className="fm-b">{renderValue(item.mbrasNm)}</span>
                </div>
            </div>

            <div className="pt20 bdt1 bdcDDDDDD">
                <div className="taC fm-b fs23 ls06">전국우정노동조합</div>
                <div className="mt10 taR fm-c fs12 fc333333">출력일자: {printDate}</div>
            </div>
        </div>
    );
};

export default MbrasInfoPdf;
